import axios, { CancelTokenSource } from 'axios';
import { useCallback, useRef } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useUpdateReceiptApi = (receiptId: string) => {
  const reqRef = useRef<CancelTokenSource>();

  const call = useCallback(
    async (data?: any) => {
      if (!data) return {} as any;
      const req = axios.CancelToken.source();
      if (reqRef.current) {
        reqRef.current.cancel();
      }
      reqRef.current = req;

      const res = await axiosInstance.put(api.updateReceipt(receiptId), data, {
        cancelToken: req.token,
      });
      return res.data;
    },
    [receiptId]
  );

  const { execute, isLoading, status } = useAsync(call, false, undefined, {});

  return { updateReceipt: execute, isUpdatingReceipt: isLoading, status, reqRef };
};

export default useUpdateReceiptApi;
